// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"extract":true,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=data-v-2118c5ee&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/layouts/Logo.vue
// module id = 276
// module chunks = 2